import styled from "styled-components";

export const LoadingWrapper = styled.div`
  margin: 10% auto;
`;
